import { z } from 'zod';
import type { BaseEntity } from './common';

/**
 * Interfaccia per Task
 * Utilizzabile sia per response (GET) che per payload (POST/PUT)
 */
export interface Task extends BaseEntity {
	/** Codice identificativo del task */
	code: string;
	/** Nome del task */
	name: string;
}

/**
 * Tipo per il risultato dell'autocomplete Tasks
 * Corrisponde ai campi selezionati nella query OData: id, code, name
 */
export type TaskAutocompleteResult = Pick<Task, 'id' | 'code' | 'name'>;

/**
 * Schema Zod per la validazione runtime di Task
 * Basato sull'interfaccia Task con BaseEntity
 */
export const TaskSchema = z.object({
	// Proprietà base da BaseEntity (opzionali come negli altri schemi)
	id: z.number(),
	createdAt: z.string().optional(), // Può essere undefined in alcuni contesti API
	createdBy: z.string().optional(), // Può essere undefined in alcuni contesti API
	modifiedAt: z.string().nullish(), // Può essere null nel JSON
	modifiedBy: z.string().nullish(), // Può essere null nel JSON

	// Proprietà specifiche di Task
	code: z.string().min(1), // Required, non vuoto
	name: z.string().min(1), // Required, non vuoto
});
